import { useState ,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion , AnimatePresence } from 'framer-motion';
import { CgMenuRight } from 'react-icons/cg';
import { RxCross2 } from 'react-icons/rx';
import { FaWhatsapp, FaArrowCircleRight } from 'react-icons/fa';
import { FiChevronRight , FiArrowRight , FiCheck , FiChevronDown, FiChevronUp} from "react-icons/fi";
import { HiArrowRight } from "react-icons/hi";

//components
import TechStack from '../../Components/TechStack/TechStack';
import FeedbackCard from '../../Components/UIVerse/FeedbackCard';
import LogoCarousel from '../../Components/UIVerse/logoSlider';
//Cards
import ProjectsCard from  './ProjectCard_lp.js'
import Industries from './Industry_lp.js';
//Data
import services from "../../Data/Services.js";
import features from "../../Data/Feature.js";
import projects from "./ProjectsData_lp.js";
import Faqs from '../../Data/Faqs.js';
import AboutUs from '../../Assets/Mern-DIgital-About-Us.jpg';

import Float from './FloatButton.js';
import './ThankYou'
import LeadFormModal from './LeadFormModal.js';
import CallButton from './CallButton';
import { Helmet } from 'react-helmet';

import emailjs from '@emailjs/browser';
import toast, { Toaster } from 'react-hot-toast';

const LandingPage = () => {

const startDate = new Date(2009, 10, 29); // Month is 0-indexed: 10 = November

  const calculateDuration = () => {
    const now = new Date();
    let years = now.getFullYear() - startDate.getFullYear();
    let months = now.getMonth() - startDate.getMonth();
    let days = now.getDate() - startDate.getDate();
    let hours = now.getHours() - startDate.getHours();
    let minutes = now.getMinutes() - startDate.getMinutes();
    let seconds = now.getSeconds() - startDate.getSeconds();

    // Handle negative values by borrowing from larger units
    if (seconds < 0) {
      seconds += 60;
      minutes--;
    }
    if (minutes < 0) {
      minutes += 60;
      hours--;
    }
    if (hours < 0) {
      hours += 24;
      days--;
    }
    if (days < 0) {
      months--;
      // Get last month’s total days
      const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      months += 12;
      years--;
    }

    return `${years}Y ${months}m ${days}d ${hours}h ${minutes}m ${seconds}s`;
  };
  const [duration, setDuration] = useState(calculateDuration());

  useEffect(() => {
    const timer = setInterval(() => {
      setDuration(calculateDuration());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

const stats = [
  { 
    value: duration, 
    label: "helping business to grow and find their goals", 
    color: "text-blue-500" 
  },
  { 
    value: "250+ Projects", 
    label: "completed since we started", 
    color: "text-purple-500" 
  },
  { 
    value: "39 Peoples", 
    label: "are works from 5 countries", 
    color: "text-green-500" 
  },
  { 
    value: "0 Offices", 
    label: "We work from Everywhere to deliver anywhere", 
    color: "text-pink-500" 
  },
  { 
    value: ">1M", 
    label: "Saved for our Clients because of 0 Office", 
    color: "text-orange-500" 
  },
  { 
    value: "90% ", 
    label: "of Our Business Comes from repeat Customer", 
    color: "text-yellow-500" 
  },
];
const schemaPageData = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://merndigital.com/lp/full-stack-webdevelopment-and-digital-marketing/#webpage",
  "url": "https://merndigital.com/lp/full-stack-webdevelopment-and-digital-marketing",
  "name": "Full Stack Web Development & Digital Marketing Agency - Mern Digital",
  "description": "Mern Digital is a full-service web development and digital marketing agency specializing in MERN stack applications, SEO, PPC, social media marketing, content marketing, e-commerce solutions, and branding for businesses worldwide.",
  "inLanguage": "en",
  "isPartOf": {
    "@type": "WebSite",
    "@id": "https://merndigital.com/lp/full-stack-webdevelopment-and-digital-marketing/#website",
    "url": "https://merndigital.com/lp/full-stack-webdevelopment-and-digital-marketing",
    "name": "Mern Digital"
  },
  "about": {
    "@type": "Organization",
    "name": "Mern Digital",
    "url": "https://merndigital.com/lp/full-stack-webdevelopment-and-digital-marketing",
    "logo": "https://www.merndigital.com/logo.png",
    "sameAs": [
      "https://www.facebook.com/merndigital"
    //   "https://www.instagram.com/merndigital",
    //   "https://www.linkedin.com/company/merndigital",
    //   "https://twitter.com/merndigital"
    ]
  },
  "mainEntity": {
    "@type": "OfferCatalog",
    "name": "Mern Digital Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Web Development",
          "description": "Custom websites, web apps, and portals using modern frameworks including MERN stack.",
          "serviceType": "Web Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "MERN Stack Development",
          "description": "Full-stack applications using MongoDB, Express.js, React.js, and Node.js for high-performance solutions.",
          "serviceType": "MERN Stack Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Search Engine Optimization (SEO)",
          "description": "Improve your website’s ranking on search engines with keyword optimization, technical SEO, and backlink strategies.",
          "serviceType": "SEO"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pay Per Click (PPC)",
          "description": "Google Ads, Bing Ads, and social media paid campaigns for targeted lead generation.",
          "serviceType": "PPC Advertising"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Social Media Marketing",
          "description": "Social media strategy, content creation, and ad campaigns for platforms like Facebook, Instagram, and LinkedIn.",
          "serviceType": "Social Media Marketing"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Content Marketing",
          "description": "Engaging blog posts, infographics, and video content for brand awareness and SEO.",
          "serviceType": "Content Marketing"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "E-commerce Development",
          "description": "Custom e-commerce websites with secure payment integration and scalable solutions.",
          "serviceType": "E-commerce Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Branding",
          "description": "Brand identity design including logos, color schemes, and style guidelines.",
          "serviceType": "Branding"
        }
      }
    ]
  }

};
const schemaFaqData = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the MERN stack and why do you use it?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The MERN stack is a collection of four powerful technologies: MongoDB, Express.js, React, and Node.js. We use it because it's a unified, JavaScript-based stack that allows us to build fast, scalable, and modern web applications with a single language for both the front-end and back-end. This results in more efficient development and a more robust final product."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to build a custom website or web application?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The timeline for a project varies depending on its complexity, features, and your specific requirements. A simple website might take a few weeks, while a complex e-commerce platform or custom application could take several months. We will provide a detailed project timeline after our initial discovery and planning phase."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer ongoing maintenance and support after the project is complete?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we do. We offer a variety of maintenance and support packages to ensure your website or application remains secure, up-to-date, and performs optimally. Our services include security patches, bug fixes, performance monitoring, and content updates."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help me migrate my existing website to a new platform or CMS?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. We specialize in website migration and CMS upgrades. Whether you're moving from an older platform to a modern CMS like WordPress or want to switch to a more powerful headless CMS, we ensure a seamless transition with no data loss and minimal disruption to your online presence."
      }
    },
    {
      "@type": "Question",
      "name": "What is the difference between SEO and PPC?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "SEO (Search Engine Optimization) focuses on improving your website's organic (unpaid) ranking in search results. It's a long-term strategy that builds credibility and drives sustainable traffic. PPC (Pay-Per-Click), on the other hand, involves paying for ad placements on search engines and social media platforms to drive immediate, targeted traffic. We recommend a combination of both for the best results."
      }
    },
    {
      "@type": "Question",
      "name": "How much do your services cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our pricing is based on the scope and complexity of your project. We provide a custom quote for each client after a detailed consultation to understand your goals, requirements, and budget. We believe in full transparency and will provide a clear breakdown of all costs."
      }
    },
    {
      "@type": "Question",
      "name": "Can you work with our existing CMS, like WordPress or Shopify?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Our expertise extends to the most popular Content Management Systems. We can develop custom themes, build bespoke plugins, and provide comprehensive maintenance and optimization for your existing WordPress, Shopify, or other CMS-powered sites."
      }
    },
    {
      "@type": "Question",
      "name": "How do you measure the success of your digital marketing campaigns?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We are a data-driven agency. We track key performance indicators (KPIs) such as website traffic, lead generation, conversion rates, and Return on Ad Spend (ROAS). We provide regular, easy-to-understand reports and dashboards so you can see the direct impact of our work on your bottom line."
      }
    },
    {
      "@type": "Question",
      "name": "What if I have a limited budget?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We work with clients of all sizes and budgets. During our initial consultation, we can help you prioritize your needs and create a phased plan that allows you to start with the most impactful services and scale up as your business grows."
      }
    },
    {
      "@type": "Question",
      "name": "How do we get started?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Getting started is easy! Simply contact us through our website or give us a call to schedule a free consultation. We'll discuss your business goals, a project brief, and how we can help you achieve them."
      }
    }
  ]
};

  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    number: '',
    message: ''
  });
  const navigate = useNavigate();

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const [activeCategory, setActiveCategory] = useState(0);
    const sendEmail = (e) => {
      e.preventDefault(); // Prevent default form submission

      emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        e.target, // The form element itself
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then((result) => {
          console.log(result.text);
          toast.success('Email sent successfully!');
          setTimeout(() => {
           handleSubmit(e);
          }, 1000); // Redirect after 1.5seconds  
      }, (error) => {
          console.log(error.text);
          toast.error("Failed to send email. Please try again.");
      });
    };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
   
    navigate('/lp/full-stack-webdevelopment-and-digital-marketing/thank-you', { state: { formData } });
  };

  //Faqs
const [expanded, setExpanded] = useState(false);
const [openIndex, setOpenIndex] = useState(null);
const featuredFaqs = Faqs.slice(0, 2); // First 2 FAQs as featured
const allFaqs = Faqs; // All FAQs

// Separate function for toggling individual FAQ items
const toggleFAQ = (index) => {
  setOpenIndex(openIndex === index ? null : index);
};

// Separate function for toggling expanded state
const toggleExpanded = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setExpanded(!expanded);
  // Optionally close all FAQs when collapsing
  if (expanded) {
    setOpenIndex(null);
  }
};

  return (
    <div className="bg-gradient-to-br from-gray-900 to-slate-800 text-white">
      <Helmet>
        <title>Full Stack Web Development & Digital Marketing Agency - Mern Digital</title>
        <meta name="description" content="Mern Digital is a full-service web development and digital marketing agency specializing in MERN stack applications, SEO, PPC, social media marketing, content marketing, e-commerce solutions, and branding for businesses worldwide." />
        <meta name="keywords" content="Mern Digital, technology solutions, digital innovation, business growth, software development, web development, mobile app development, digital transformation" />
        <script type='application/ld+json'>
            {JSON.stringify(schemaFaqData)}
        </script>
        <script type='application/ld+json'>
            {JSON.stringify(schemaPageData)}
        </script>
        <link rel="canonical" href="https://merndigital.com/lp/full-stack-webdevelopment-and-digital-marketing" />
      </Helmet>
      {/* Floating WhatsApp Button */}
      <Float />
      <LeadFormModal/>
      {/* Navigation */}
<nav className="fixed top-0 left-0 right-0 z-30 w-full bg-gray-600 bg-opacity-30 shadow-md backdrop-blur-xl">
  <div className="container mx-auto px-6 py-3">
    <div className="flex items-center justify-between">
      {/* Logo */}
      <div className="flex items-center">
        <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-3xl font-semibold text-transparent">
          Mern Digital
        </span>
      </div>

      {/* Desktop Menu & CTAs - Combined and hidden on mobile */}
      <div className="hidden items-center space-x-8 md:flex">
        <a href="#services" className="transition duration-300 hover:text-blue-400">Services</a>
        <a href="#industries" className="transition duration-300 hover:text-blue-400">Industries</a>
        <a href="#about" className="transition duration-300 hover:text-blue-400">About</a>
        <a href="#testimonials" className="transition duration-300 hover:text-blue-400">Testimonials</a>
        <a href="#faq" className="transition duration-300 hover:text-blue-400">FAQ</a>
        
        {/* CTA Buttons for Desktop */}
        <div className="flex items-center gap-4">
          <CallButton />
          <a
            href="https://api.whatsapp.com/send?phone=+918101463629&text=Hello%20Mern%20Digital,%20I%20would%20like%20to%20know%20more%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
          >
            <button className="relative flex items-center gap-2 px-4 py-2 w-[160px] text-[15px] font-semibold text-[#7EB9EC] rounded-full border-[3px] border-double border-[rgba(74,61,255,0.75)] bg-gradient-to-r from-[#0E0F3A] to-[#310376] transition-all duration-300  hover:border-[#642BD7] hover:shadow-md hover:text-[15px]">
              <FaWhatsapp className='h-5 w-5'/> 8101463629
            </button>
          </a>
        </div>
      </div>

      {/* Mobile Menu Toggle Button - Hidden on desktop */}
      <div className="flex items-center md:hidden">
        <button
          onClick={handleToggle}
          aria-label={isOpen ? 'Close menu' : 'Open menu'}
          className="text-3xl text-blue-400 transition-transform duration-300 ease-in-out hover:text-purple-400"
        >
          {isOpen ? <RxCross2 /> : <CgMenuRight />}
        </button>
      </div>
    </div>

    {/* Mobile Menu - Dropdown */}
    {isOpen && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        className="mt-4 md:hidden"
        onClick={handleToggle} // Closes menu when a link is clicked
      >
        <div className="flex flex-col items-center space-y-3 text-center">
          <a href="#services" className="block w-full rounded py-2 transition duration-300 hover:bg-gray-700 hover:text-blue-400">Services</a>
          <a href="#industries" className="block w-full rounded py-2 transition duration-300 hover:bg-gray-700 hover:text-blue-400">Industries</a>
          <a href="#about" className="block w-full rounded py-2 transition duration-300 hover:bg-gray-700 hover:text-blue-400">About</a>
          <a href="#testimonials" className="block w-full rounded py-2 transition duration-300 hover:bg-gray-700 hover:text-blue-400">Testimonials</a>
          <a href="#faq" className="block w-full rounded py-2 transition duration-300 hover:bg-gray-700 hover:text-blue-400">FAQ</a>
        </div>
        
        {/* CTA Buttons for Mobile */}
        <div className="mt-6 flex flex-row items-center gap-4 border-t border-gray-500 pt-4">
          <CallButton/>
          <a
            href="https://api.whatsapp.com/send?phone=+918101463629&text=Hello%20Mern%20Digital,%20I%20would%20like%20to%20know%20more%20about%20your%20services."
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            className="w-full"
          >
            <button className="relative flex items-center gap-2 px-4 py-2 w-[160px] text-[15px] font-semibold text-[#7EB9EC] rounded-full border-[3px] border-double border-[rgba(74,61,255,0.75)] bg-gradient-to-r from-[#0E0F3A] to-[#310376] transition-all duration-300  hover:border-[#642BD7] hover:shadow-md hover:text-[15px]">
              <FaWhatsapp className='h-5 w-5'/> 8101463629
            </button>
          </a>
        </div>
      </motion.div>
    )}
  </div>
</nav>

      {/* Hero Section with Lead Form */}
      <section className="pt-32 pb-10 px-4 bg-gradient-to-b from-gray-800 to-gray-900">
  <div className="container mx-auto max-w-8xl">
    <div className="flex flex-col lg:flex-row items-center gap-12">
      {/* Content Section */}
      <div className="lg:w-2/3 mb-12 lg:mb-0">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white"
        >
          Transform Your Business With <span className="text-blue-400 bg-gradient-to-r from-blue-400 to-purple-600 bg-clip-text text-transparent">Digital Innovation</span>
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="text-xl text-gray-300 mb-8 max-w-2xl"
        >
          We deliver cutting-edge technology solutions that drive growth, efficiency, and competitive advantage for your business.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="flex flex-wrap gap-4"
        >
          <a href='#services'>
          <button className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl">
            Our Services
          </button></a>
          <a href='#faq'>
          <button className="px-8 py-3 border border-blue-400 text-blue-400 hover:bg-blue-900/30 rounded-lg font-medium transition-all duration-300">
            FAQs
          </button></a>
        </motion.div>
      </div>

      {/* Lead Form Section */}
      <motion.div 
        id="leadForm"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="lg:w-1/3 w-full"
      >
        <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl shadow-2xl overflow-hidden p-4">
          <h3 className="text-2xl font-bold text-center mb-6 text-white">
            Schedule a Free Consultation
          </h3>
          
          <form className="space-y-5" onSubmit={sendEmail}>
            <div className="space-y-1">
              <input 
                type="text" 
                id="name"
                name="FullName"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 transition-all"
                placeholder="Full Name"
                required
                aria-label="Full Name"
              />
            </div>
            
            <div className="space-y-1">
              <input 
                type="email" 
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 transition-all"
                placeholder="Email Address"
                required
                aria-label="Email Address"
              />
            </div>
            
            <div className="space-y-1">
              <input 
                type="tel" 
                id="number"
                name="number"
                value={formData.number}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 transition-all"
                placeholder="Phone Number"
                aria-label="Phone Number"
              />
            </div>
            
            <div className="space-y-1">
              <textarea 
                id="message"
                name="message"
                rows="4"
                value={formData.message}
                onChange={handleInputChange}
                className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-white placeholder-gray-400 transition-all"
                placeholder="Tell us about your project..."
                aria-label="Your Message"
              ></textarea>
            </div>
            
            <button 
              type="submit"
              className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3.5 rounded-lg font-semibold hover:from-blue-600 hover:to-blue-700 transition-all duration-300 shadow-lg hover:shadow-blue-500/20 flex items-center justify-center gap-2"
              aria-label="Submit consultation request"
            >
              <span>Request Consultation</span>
              <FiArrowRight className="h-5 w-5" />
            </button>
          </form>
          
         
        </div>
      </motion.div>
    </div>
  </div>
  
  <Toaster
    position="top-center"
    reverseOrder={false}
    toastOptions={{
      className: 'bg-gray-800 text-white border border-gray-700',
      duration: 5000,
    }}
  />
</section>

      {/* Partners Logo Slider - Infinite Loop */}
      <section className="py-10 overflow-hidden sm:px-40">
        <LogoCarousel/>
      </section>

      {/* About Section */}
      <section id="about" className="py-10">
  <div className="container mx-auto px-4">
    <div className="flex flex-col lg:flex-row items-center">
      <div className="lg:w-1/2 mb-12 lg:mb-0 lg:pr-12">
        <motion.img 
          src={AboutUs} 
          alt="Our Team" 
          className="rounded-xl shadow-xl h-[calc(100vh-450px)] object-cover w-full"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        />
      </div>
      <div className="lg:w-1/2">
        <h2 className="text-3xl md:text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-6">
          About Mern Digital
        </h2>

        <p className="text-lg text-white mb-6">
          <strong>Where Technical Excellence Meets Digital Strategy</strong>
        </p>

        <p className="text-lg text-white mb-6">
          MERN DIGITAL is a full-stack development and digital marketing agency with 15+ years of experience crafting high-performance web solutions. We combine deep technical expertise in the MERN stack with data-driven marketing strategies to deliver measurable business results.
        </p>

        <div className="space-y-4 mb-8">
          <div className="flex items-start">
            <FiCheck className="text-green-500 mt-1 mr-3 flex-shrink-0" />
            <p className="text-white">150+ successful projects delivered worldwide</p>
          </div>
          <div className="flex items-start">
            <FiCheck className="text-green-500 mt-1 mr-3 flex-shrink-0" />
            <p className="text-white">95% client retention rate</p>
          </div>
          <div className="flex items-start">
            <FiCheck className="text-green-500 mt-1 mr-3 flex-shrink-0" />
            <p className="text-white">End-to-end solutions from development to growth marketing</p>
          </div>
        </div>

        <p className="text-lg text-white">
          We partner with ambitious businesses to build scalable digital products and growth strategies that stand the test of time. Our global experience across industries gives us unique insights to tailor solutions for your specific market needs.
        </p>
      </div>
    </div>
  </div>
</section>

      {/* Features Section */}
      <section className="py-16 md:py-24 bg-gray-900 relative overflow-hidden">
  {/* Floating gradient lights */}
  <div className="absolute -top-20 -left-20 w-64 h-64 bg-blue-600/10 rounded-full filter blur-3xl"></div>
  <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-purple-600/10 rounded-full filter blur-3xl"></div>

  <div className="container mx-auto px-4 sm:px-6">
    {/* Header */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-center mb-12 md:mb-20"
    >
      <h2 className="text-3xl md:text-5xl font-bold mb-4">
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
          Why We're Different
        </span>
      </h2>
      <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
        Discover our unique approach to solving your challenges
      </p>
    </motion.div>

    {/* Interactive "Neon" Cards */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {features.map((feature, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: index * 0.1 }}
          viewport={{ once: true }}
          className="relative group"
        >
          {/* Card */}
          <div className="h-full bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 md:p-8 overflow-hidden transition-all duration-300 group-hover:border-blue-400/50">
            {/* Neon glow effect */}
            <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            
            {/* Animated border */}
            <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-blue-400/20 pointer-events-none transition-all duration-500"></div>
            
            {/* Icon with pulse animation */}
            <div className="relative mb-6">
              <div className="absolute -inset-2 bg-blue-500/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className={`relative w-14 h-14 rounded-lg flex items-center justify-center text-3xl ${feature.color}`}>
                {feature.icon}
              </div>
            </div>
            
            <h3 className="text-xl md:text-2xl font-bold mb-3 text-white">
              {feature.title}
            </h3>
            <p className="text-gray-300 mb-6">
              {feature.description}
            </p>
            
            {/* Interactive button */}
            
          </div>
          
          {/* Floating indicator */}
          <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white text-xs font-bold shadow-lg">
            {index + 1}
          </div>
        </motion.div>
      ))}
    </div>

    {/* CTA with subtle animation */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      viewport={{ once: true }}
      className="mt-16 text-center"
    >
<a href='#leadForm'>      <button className="px-8 py-3.5 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg font-bold hover:shadow-lg hover:shadow-blue-500/20 transition-all flex items-center justify-center gap-2 mx-auto">
        Start Your Journey
        <HiArrowRight className="h-5 w-5" />
      </button></a>
    </motion.div>
  </div>
</section>

      {/*Speaking Numbers */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-1 text-sm font-semibold tracking-wider text-blue-300 uppercase rounded-full bg-blue-900/30 mb-4">
            Our Impact
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Numbers That <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Speak</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Quantifying our success through measurable achievements and client satisfaction
          </p>
        </motion.div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
              className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8 border border-gray-700/30 hover:border-gray-600/50 transition-all"
            >
              <div className='inline-flex gap-6'>
              
              <h3 className="text-4xl font-bold text-white mb-2">
                {stat.value}
              </h3></div>
              <p className="text-lg text-gray-300">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Optional CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <p className="text-gray-400 mb-6">Ready to add your success to our numbers?</p>
          <a href='#leadForm'><button className="px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-medium rounded-lg hover:shadow-lg transition-all">
            Get Started Today
          </button></a>
        </motion.div>
      </div>
    </section>

      {/* Services Section */}
<section id="services" className="py-16 md:py-24 relative overflow-hidden">
  
  
  {/* Animated gradient circles */}
  <div className="absolute inset-0 overflow-hidden -z-10">
    <div className="absolute top-1/3 -left-20 w-80 h-80 bg-purple-600/10 rounded-full filter blur-3xl animate-float"></div>
    <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-blue-600/10 rounded-full filter blur-3xl animate-float-delay"></div>
  </div>

  <div className="container mx-auto px-4 sm:px-6">
    {/* Header with decorative elements */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-center mb-0 relative"
    >
      <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-16 h-1 bg-gradient-to-r from-transparent via-blue-400 to-transparent opacity-60"></div>
      <h2 className="text-4xl md:text-5xl font-bold mb-4 ">
        <span className="relative inline-block">
          <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-300 to-purple-300">
            Our Services
          </span>
          <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full opacity-80"></span>
        </span>
      </h2>
      <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
        Innovative solutions tailored to your digital transformation
      </p>
    </motion.div>

    {/* Tabbed category navigation */}
    <div className="max-w-5xl py-6 mx-auto">
      <div className="flex overflow-x-auto pb-2 scrollbar-hide">
        <div className="flex space-x-2 mx-auto">
          {services.map((category, index) => (
            <motion.button
              key={index}
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => setActiveCategory(index)}
              className={` px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                activeCategory === index
                  ? 'bg-white/10 font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 border border-white/20 backdrop-blur-sm'
                  : 'text-gray-400 hover:text-white hover:bg-white/5'
              }`}
            >
              {category.category}
            </motion.button>
          ))}
        </div>
      </div>
    </div>

    {/* Services showcase */}
    <div className="max-w-6xl mx-auto">
      <motion.div
        key={activeCategory}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {services[activeCategory].items.map((service, index) => {
          const IconComponent = service.icon;
          return (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.05, duration: 0.4 }}
              viewport={{ once: true, margin: "-30px" }}
              className="group relative h-full"
              key={index}
            >
              {/* Hover effect background */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 to-purple-900/20 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10"></div>
              
              <div className="h-full bg-gray-900/50 backdrop-blur-sm border border-gray-800 rounded-2xl p-6 transition-all duration-300 group-hover:border-gray-700">
                {/* Icon with gradient border */}
                <div className="relative w-14 h-14 mb-5">
                  <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-400 to-purple-500 opacity-20 group-hover:opacity-30 transition-opacity"></div>
                  <div className="absolute inset-1 rounded-lg bg-gray-900/80 backdrop-blur-sm flex items-center justify-center">
                    <IconComponent className="text-2xl" style={{ color: service.color }} />
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
                <p className="text-gray-400 mb-4">{service.description}</p>
                
                <div className="flex items-center justify-between">
                  <motion.a
                    href="#leadForm"
                    whileHover={{ x: 3 }}
                    className="text-sm font-medium text-blue-400 hover:text-blue-300 flex items-center"
                  >
                    Get a Quote
                    
                  <FiChevronRight className="h-4 w-4 ml-1" />
                  </motion.a>
                  
                  <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse opacity-0 group-hover:opacity-100 transition-opacity"></div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </motion.div>
    </div>

    {/* CTA with animated border */}
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      viewport={{ once: true }}
      className="mt-20 text-center relative max-w-2xl mx-auto"
    >
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-600/20 via-transparent to-purple-600/20 opacity-60 -z-10"></div>
      <div className="absolute inset-0 rounded-2xl border border-dashed border-white/10 pointer-events-none"></div>
      
      <div className="p-8 md:p-10">
        <h3 className="text-2xl font-bold text-white mb-4">Ready to transform your vision?</h3>
        <p className="text-gray-400 mb-6">Let's build something extraordinary together</p>
        
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="relative bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-3 rounded-full font-medium shadow-lg hover:shadow-xl transition-all"
        ><a href='#leadForm'>
          <span className="relative z-10 flex items-center justify-center gap-2">
            Start Your Project
            
<FaArrowCircleRight className="h-5 w-5" />
          </span>
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-500/30 to-purple-500/30 opacity-0 hover:opacity-100 transition-opacity -z-10"></div>
        </a>
        </motion.button>
      </div>
    </motion.div>
  </div>
</section>
      
      {/* Banner */}
    <div className="relative bg-gradient-to-br from-indigo-900 via-purple-900 to-gray-900 rounded-2xl overflow-hidden shadow-2xl mx-4 my-8 max-w-6xl lg:mx-auto">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-20 h-20 sm:w-32 sm:h-32 bg-purple-500 rounded-full mix-blend-overlay filter blur-lg"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 sm:w-40 sm:h-40 bg-indigo-500 rounded-full mix-blend-overlay filter blur-lg"></div>
      </div>
      
      <div className="relative mx-auto py-8 sm:py-12 md:py-16 px-4 sm:px-6 md:px-8">
        <div className="text-center">
          {/* Equation container with responsive sizing */}
          <div className="inline-flex flex-col sm:flex-row items-center justify-center mb-6 sm:mb-8 md:mb-10 p-4 sm:p-5 md:p-6 bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-white/20">
            <div className="flex items-center space-x-2 sm:space-x-3 md:space-x-4">
              <span className="text-3xl sm:text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">
                MERN Digital
              </span>
              <span className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">+</span>
              <span className="text-3xl sm:text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-rose-400">
                Your IDEA 
              </span>
            </div>
            
            <div className="sm:mx-4 md:mx-6 my-3 sm:my-0">
              <span className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">=</span>
            </div>
            
            <div className="text-center sm:text-left mt-4 sm:mt-0">
              <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-yellow-400 leading-tight">
                Magical Growth<br className="hidden sm:inline"/> 
              </h2>
            </div>
          </div>
          
          {/* CTA section with responsive spacing */}
          <div className="mt-8 sm:mt-10 md:mt-12 space-y-4 sm:space-y-6">
            <p className="text-base sm:text-lg text-white/80 max-w-2xl mx-auto">
              Harness the power of cutting-edge technology and strategic marketing to skyrocket your business
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
              <a href='#leadForm'>
              <button className="px-6 py-3 sm:px-8 sm:py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold rounded-lg sm:rounded-xl hover:shadow-lg hover:shadow-cyan-500/30 transition-all duration-300 text-sm sm:text-base">
                Get a Free Consultation
              </button></a>
              <a href='#projects'>
              <button className="px-6 py-3 sm:px-8 sm:py-4 bg-transparent border-2 border-white/30 text-white font-bold rounded-lg sm:rounded-xl hover:bg-white/10 transition-all duration-300 text-sm sm:text-base">
                View Our Works
              </button></a>
            </div>
          </div>
        </div>
      </div>
      
      {/* Corner accents - responsive sizing */}
      <div className="absolute top-0 left-0 w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 border-t-2 border-l-2 border-cyan-400 rounded-tl-lg sm:rounded-tl-xl md:rounded-tl-2xl"></div>
      <div className="absolute bottom-0 right-0 w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 border-b-2 border-r-2 border-pink-400 rounded-br-lg sm:rounded-br-xl md:rounded-br-2xl"></div>
    </div>

      {/* Industries Section */}
      <section id="industries" className="">
        <Industries/>
      </section>

        {/* Technology Stack */}
      <section className=" ">
        <TechStack/>
      </section>

      {/* Projects Section */}
      <section id='projects' className="py-20 ">
        <h2 className="text-4xl md:text-5xl font-bold mb-4 text-center">
        <span className="relative inline-block">
          <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
            Our Projects
          </span>
          {/* <span className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full opacity-80"></span> */}
        </span>
      </h2>
      <div className='flex flex-wrap justify-center items-center gap-4 px-6 sm:px-20'>
        {projects.map((project) => (
        <ProjectsCard key={project.id} project={project}/>
      ))}</div>
      </section>

      {/* FAQs */}
     <section id="faq" className="py-16 md:py-24 bg-gradient-to-b from-gray-900 to-gray-800">
  <div className="container mx-auto px-4 max-w-4xl">
    <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
      Frequently Asked Questions
    </h2>
    
    <div className="space-y-3">
      {(expanded ? allFaqs : featuredFaqs).map((faq, index) => (
        <div 
          key={index} 
          className="rounded-lg overflow-hidden transition-all border border-gray-700 hover:border-gray-600 bg-gray-800/50 hover:bg-gray-800/70"
        >
          <button
            onClick={() => toggleFAQ(index)}
            className="w-full flex justify-between items-center p-5 md:p-6 text-left group focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 rounded-lg"
            aria-expanded={openIndex === index}
            aria-controls={`faq-answer-${index}`}
          >
            <span className="text-lg md:text-xl font-semibold text-white group-hover:text-blue-400 transition-colors">
              {faq.question}
            </span>
            <div className={`ml-4 p-1 rounded-full transition-all ${openIndex === index ? 'bg-blue-600 rotate-180' : 'bg-gray-700'}`}>
              {openIndex === index ? (
                <FiChevronUp className="h-5 w-5 text-white" />
              ) : (
                <FiChevronDown className="h-5 w-5 text-white" />
              )}
            </div>
          </button>

          <AnimatePresence>
            {openIndex === index && (
              <motion.div
                id={`faq-answer-${index}`}
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                className="px-6 pb-6 text-gray-300 text-start"
              >
                <div className="prose prose-invert max-w-none">
                  {faq.answer}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>

    <div className="mt-8 text-center">
      <button 
        type="button"
        onClick={toggleExpanded}
        className="inline-flex items-center text-blue-400 hover:text-blue-300 font-medium px-5 py-2.5 rounded-lg transition-colors bg-gray-800 hover:bg-gray-700"
      >
        {expanded ? 'Show fewer questions' : 'See all questions'}
        {expanded ? (
          <FiChevronUp className="ml-2 h-5 w-5" />
        ) : (
          <FiChevronDown className="ml-2 h-5 w-5" />
        )}
      </button>
    </div>
  </div>
</section>

      {/* Testimonials */}
      <section id="testimonials" className="py-20">
        <FeedbackCard/>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-purple-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Transform Your Business?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Get started with our solutions today and experience the difference.
          </p>
          <div className="flex  justify-center">
            <a href="#leadForm">
            <button className="w-48 border border-white text-white px-8 py-3 rounded-full hover:bg-white hover:bg-opacity-10 transition">
              Contact Sales
            </button></a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="container mx-auto px-6 text-center">
          
          <p>© {new Date().getFullYear()} Mern Digital. All rights reserved.</p>
          
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;